/* Cart offers / free gifts. Settings: Theme settings > Cart > Progress bar.
   Brand Katha fix 23 Oct 2026: free gift is auto-added every time the cart qualifies (also after the cart is emptied). */
(function () {
  if (!window.customElements.get("cart-offers")) {
    var e = "free_gift",
      t = "buy_x_get_y",
      i = "_free_gift",
      r = "bkOffersOpenPicker",
      n = "bkOffersFixTries",
      s = "bkOffersConfetti",
      a = !1,
      o = !1,
      c = 0,
      l = ["cart-drawer", "cart-icon-bubble"];
    class p2 extends HTMLElement {
      connectedCallback() {
        if (!this.bkReady && ((this.bkReady = !0), (this.cfg = d()), this.cfg)) {
          var i2,
            n2,
            s2,
            a2,
            o2,
            c2 = this.querySelector("[data-bk-cart]");
          try {
            this.cart = c2 ? JSON.parse(c2.textContent) : this.bkCart || null;
          } catch {
            this.cart = null;
          }
          if (
            (this.cfg && bkLoadAllCached(this.cfg),
            this.cart &&
              ((this.scope = this.closest("#CartDrawer") || document),
              (this.state =
                ((i2 = this.cfg),
                (n2 = this.cart),
                (s2 = (n2 && n2.items) || []),
                (a2 = {}),
                (o2 = { value: 0, milestones: [], giftLines: [], invalidKeys: [], fixQtyKeys: [] }),
                (i2.milestones || []).forEach(function (e2) {
                  var t2 = { m: e2, lines: [], eligibleQty: 0, discountSeen: !1, eligibleIds: {} };
                  (e2.products || []).forEach(function (e3) {
                    t2.eligibleIds[e3.id] = !0;
                  }),
                    (a2[e2.id] = t2),
                    o2.milestones.push(t2);
                }),
                s2.forEach(function (e2) {
                  if (e2.gift) {
                    o2.giftLines.push(e2);
                    var i3 = a2[e2.gift];
                    i3 && i3.m.type !== "discount"
                      ? (i3.lines.push(e2),
                        e2.final_line_price < e2.original_line_price && (i3.discountSeen = !0))
                      : o2.invalidKeys.push(e2.key);
                  } else
                    (o2.value += e2.original_line_price),
                      o2.milestones.forEach(function (i4) {
                        i4.m.type === t &&
                          (i4.m.allProducts || i4.eligibleIds[e2.product_id]) &&
                          ((i4.eligibleQty += e2.quantity),
                          e2.final_line_price < e2.original_line_price && (i4.discountSeen = !0));
                      });
                }),
                o2.milestones.forEach(function (r2) {
                  var n3 = r2.m,
                    s3 = n3.type === t;
                  (r2.remaining = s3
                    ? Math.max(0, n3.threshold - r2.eligibleQty)
                    : Math.max(0, 100 * n3.threshold - o2.value)),
                    (r2.progress = s3
                      ? Math.min(1, r2.eligibleQty / n3.threshold)
                      : Math.min(1, o2.value / (100 * n3.threshold))),
                    (r2.done = r2.remaining === 0),
                    n3.type !== e || n3.gift || (r2.done = !1),
                    s3 && !n3.allProducts && !(n3.products || []).length && (r2.done = !1),
                    (r2.max = (s3 && i2.maxGifts) || 1),
                    r2.lines.forEach(function (e2, t2) {
                      !r2.done || t2 >= r2.max
                        ? o2.invalidKeys.push(e2.key)
                        : e2.quantity > 1 && o2.fixQtyKeys.push(e2.key);
                    }),
                    (r2.claimed = r2.done ? Math.min(r2.lines.length, r2.max) : 0),
                    (r2.free = r2.claimed > 0 && (s3 ? r2.discountSeen : r2.lines[0].final_line_price === 0)),
                    (r2.appliedWithoutPick =
                      s3 && r2.done && r2.claimed === 0 && r2.eligibleQty > n3.threshold && r2.discountSeen);
                }),
                /* Brand Katha (23 Oct 2026): once Buy 2 Get 1 is in use (its free product is in the cart,
                   or 3+ products), the free face wash is removed, because only one offer applies. */
                o2.milestones.forEach(function (x) {
                  i2.allowBoth ||
                    x.m.type !== t ||
                    !x.done ||
                    !(x.lines.length > 0 || x.eligibleQty > x.m.threshold) ||
                    o2.milestones.forEach(function (y) {
                      y.m.type === e &&
                        ((y.blocked = !0),
                        y.lines.forEach(function (l) {
                          o2.invalidKeys.indexOf(l.key) < 0 && o2.invalidKeys.push(l.key);
                        }),
                        (y.lines = []),
                        (y.claimed = 0),
                        (y.free = !1));
                    });
                }),
                o2)),
              this.addEventListener("click", this.onClick.bind(this)),
              this.addEventListener("change", function (e2) {
                e2.stopPropagation();
              }),
              !this.fixInvalid()))
          ) {
            this.render(),
              this.patchProgressBar(),
              this.markGiftLines(),
              this.syncTabindex(),
              this.watchCartLines(),
              this.celebrate();
            var l2 = window.sessionStorage.getItem(r);
            if (l2) {
              window.sessionStorage.removeItem(r);
              var f2 = this.milestone(l2);
              f2 && this.canClaim(f2) && this.openPicker(f2);
            } else this.autoAddGift();
          }
        }
      }
      disconnectedCallback() {
        this.sheet && this.sheet.parentNode && this.sheet.parentNode.removeChild(this.sheet),
          this.lineObserver && this.lineObserver.disconnect();
      }
      watchCartLines() {
        var e2 = this,
          t2 = this.scope.querySelector("cart-drawer-items, cart-items");
        t2 &&
          window.MutationObserver &&
          ((this.lineObserver = new MutationObserver(function () {
            e2.markGiftLines();
          })),
          this.lineObserver.observe(t2, { childList: !0, subtree: !0 }));
      }
      celebrate() {
        var e2 = window.sessionStorage.getItem(s);
        if (e2) {
          window.sessionStorage.removeItem(s);
          var t2 = this.milestone(e2);
          t2 &&
            t2.lines.length &&
            this.cfg.confetti !== !1 &&
            (function (e3, t3) {
              if (!e3 || (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches))
                return;
              var i2 = e3.getBoundingClientRect();
              if (!i2.width || !i2.height) return;
              var r2 = document.createElement("canvas");
              (r2.className = "bk-confetti"),
                (r2.width = i2.width),
                (r2.height = Math.min(i2.height, 300)),
                e3.classList.add("bk-confetti-host"),
                e3.appendChild(r2);
              var n2 = r2.getContext("2d");
              if (!n2) return r2.remove();
              for (
                var s2 = t3 ? t3.getBoundingClientRect() : i2,
                  a2 = s2.left - i2.left + s2.width / 2,
                  o2 = Math.min(r2.height - 60, Math.max(40, s2.top - i2.top + s2.height / 2)),
                  c2 = [
                    window.getComputedStyle(e3).getPropertyValue("--discount-bar-active-progress").trim() ||
                      "#a1cbaa",
                    "#f7a8c4",
                    "#a1cbaa",
                    "#ffd166",
                    "#a8d8e8",
                  ],
                  l2 = [],
                  d2 = 0;
                d2 < 44;
                d2++
              )
                l2.push({
                  x: i2.width * (0.08 + 0.84 * Math.random()),
                  y: o2 + 40 * (Math.random() - 0.5),
                  vx: 6 * (Math.random() - 0.5),
                  vy: 5 * -Math.random() - 2,
                  size: 4 * Math.random() + 3,
                  spin: 6 * Math.random(),
                  color: c2[d2 % c2.length],
                });
              var f2 = null;
              function u2(e4) {
                f2 === null && (f2 = e4);
                var t4 = e4 - f2;
                n2.clearRect(0, 0, r2.width, r2.height),
                  l2.forEach(function (e5) {
                    (e5.vy += 0.22),
                      (e5.x += e5.vx),
                      (e5.y += e5.vy),
                      (e5.spin += 0.2),
                      n2.save(),
                      (n2.globalAlpha = Math.max(0, 1 - t4 / 1300)),
                      n2.translate(e5.x, e5.y),
                      n2.rotate(e5.spin),
                      (n2.fillStyle = e5.color),
                      n2.fillRect(-e5.size / 2, -e5.size / 2, e5.size, 0.6 * e5.size),
                      n2.restore();
                  }),
                  t4 < 1300 && r2.isConnected ? window.requestAnimationFrame(u2) : r2.remove();
              }
              window.requestAnimationFrame(u2);
            })(this.closest("#CartDrawer") || document.getElementById("main-cart-items"), this);
        }
      }
      milestone(e2) {
        return this.state.milestones.filter(function (t2) {
          return t2.m.id === e2;
        })[0];
      }
      label(e2) {
        return (this.cfg.labels && this.cfg.labels[e2]) || "";
      }
      money(e2) {
        return (function (e3, t2) {
          var i2 = (Number(e3) || 0) / 100;
          function r2(e4, t3, i3, r3) {
            var n3 = e4.toFixed(t3).split(".");
            return n3[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + i3) + (n3[1] ? r3 + n3[1] : "");
          }
          var n2,
            s2 = /\{\{\s*(\w+)\s*\}\}/,
            a2 = t2 && s2.test(t2) ? t2 : "{{amount}}";
          switch (a2.match(s2)[1]) {
            case "amount_no_decimals":
              n2 = r2(i2, 0, ",", ".");
              break;
            case "amount_with_comma_separator":
              n2 = r2(i2, 2, ".", ",");
              break;
            case "amount_no_decimals_with_comma_separator":
              n2 = r2(i2, 0, ".", ",");
              break;
            default:
              n2 = r2(i2, 2, ",", ".");
          }
          var o2 = document.createElement("div");
          return (o2.innerHTML = a2.replace(s2, n2)), o2.textContent;
        })(e2, this.cfg.moneyFormat);
      }
      fixInvalid() {
        var e2 = this.state;
        if (!e2.invalidKeys.length && !e2.fixQtyKeys.length)
          return (c = 0), window.sessionStorage.removeItem(n), !1;
        if (o || c >= 3) return !1;
        if (b()) {
          var t2 = Number(window.sessionStorage.getItem(n) || 0);
          if (t2 >= 3) return !1;
          window.sessionStorage.setItem(n, String(t2 + 1));
        }
        (o = !0), (c += 1), this.markGiftLines("bk-gift-line--removing", e2.invalidKeys);
        var i2 = {};
        return (
          e2.invalidKeys.forEach(function (e3) {
            i2[e3] = 0;
          }),
          e2.fixQtyKeys.forEach(function (e3) {
            i2[e3] = 1;
          }),
          m("cart/update.js", _({ updates: i2 }))
            .then(function (e3) {
              (o = !1), g(e3);
            })
            .catch(function (e3) {
              (o = !1), console.error("cart-offers: could not update gifts", e3);
            }),
          !0
        );
      }
      autoAddGift() {
        var FLAG = "bkOffersGiftRemoved",
          ss = window.sessionStorage,
          w = window,
          gm = this.state.milestones.filter(function (x) {
            return x.m.type === "free_gift" && x.m.gift;
          })[0];
        if (!gm || this.cfg.autoAddGift === !1 || gm.blocked) return;
        if (document.querySelector(".bk-offers__sheet:not([hidden])")) return;
        if (!gm.done) return (w.bkOffersAutoTries = 0), void ss.removeItem(FLAG);
        if (gm.claimed > 0) return void (w.bkOffersAutoTries = 0);
        if (ss.getItem(FLAG) === "1" || w.bkOffersAutoBusy || o) return;
        if (!this.canClaim(gm) || !gm.m.gift.available || !gm.m.gift.variantId) return;
        if ((w.bkOffersAutoTries = (w.bkOffersAutoTries || 0) + 1) > 2) return;
        w.bkOffersAutoBusy = !0;
        var props = {};
        props[i] = gm.m.id;
        m("cart/add.js", _({ items: [{ id: gm.m.gift.variantId, quantity: 1, properties: props }] }))
          .then(function (res) {
            (w.bkOffersAutoBusy = !1), ss.setItem(s, gm.m.id), g(res);
          })
          .catch(function (err) {
            (w.bkOffersAutoBusy = !1), console.error("cart-offers: could not add free gift", err);
          });
      }
      canSwap(x) {
        return this.cfg.allowBoth ||
          x.blocked ||
          x.m.type === "discount" ||
          !x.done ||
          x.claimed > 0 ||
          x.appliedWithoutPick ||
          (x.m.type === "free_gift"
            ? !(x.m.gift && x.m.gift.available && x.m.gift.variantId)
            : !(x.m.allProducts || this.pickable(x).length))
          ? !1
          : this.state.milestones.some(function (y) {
              return y !== x && y.lines.length > 0;
            });
      }
      swapTo(x, btn) {
        var self = this,
          upd = {};
        this.state.milestones.forEach(function (y) {
          y !== x &&
            y.lines.forEach(function (l2) {
              upd[l2.key] = 0;
            });
        }),
          this.setBusy(!0, btn),
          x.m.type === "free_gift"
            ? window.sessionStorage.removeItem("bkOffersGiftRemoved")
            : window.sessionStorage.setItem("bkOffersOpenPicker", x.m.id),
          m("cart/update.js", _({ updates: upd }))
            .then(function (res) {
              (o = !1), g(res);
            })
            .catch(function (err) {
              window.sessionStorage.removeItem("bkOffersOpenPicker"), self.setBusy(!1), self.showError(err);
            });
      }
      canClaim(t2) {
        return t2.blocked ||
          t2.m.type === "discount" ||
          !t2.done ||
          t2.appliedWithoutPick ||
          t2.claimed >= t2.max ||
          (!this.cfg.allowBoth &&
            this.state.milestones.some(function (e2) {
              return e2 !== t2 && (e2.lines.length > 0 || e2.appliedWithoutPick);
            }))
          ? !1
          : t2.m.type === e || !!t2.m.allProducts || this.pickable(t2).length > 0;
      }
      pickable(e2) {
        return (e2.m.products || []).filter(function (e3) {
          return e3.available && e3.variantId;
        });
      }
      thumb(e2, t2) {
        return e2
          ? '<img class="bk-offers__thumb" src="' +
              f(e2) +
              '" alt="' +
              f(u(t2)) +
              '" width="56" height="56" loading="lazy">'
          : '<span class="bk-offers__thumb bk-offers__thumb--empty" aria-hidden="true"></span>';
      }
      render() {
        var t2 = this,
          i2 = "";
        this.state.milestones.forEach(function (r3) {
          var n3 = r3.m;
          if (n3.type !== "discount" && r3.done) {
            var s2 = '<span class="bk-offers__icon" aria-hidden="true">\u{1F381}</span>';
            if (r3.claimed > 0) {
              var a2 = n3.type === e ? n3.gift : t2.productByVariant(r3, r3.lines[0].variant_id),
                o2 = a2 ? h(a2.title) : "";
              i2 +=
                '<div class="bk-offers__card bk-offers__card--done">' +
                (a2 ? t2.thumb(a2.image, a2.title) : s2) +
                '<div class="bk-offers__text"><p class="bk-offers__title">' +
                f(r3.free ? n3.claimed : t2.label("notApplied")) +
                '</p><p class="bk-offers__sub">' +
                f(o2) +
                "</p></div>" +
                (r3.free ? '<strong class="bk-offers__free">' + f(t2.label("free")) + "</strong>" : "") +
                "</div>";
            } else if (r3.appliedWithoutPick)
              i2 +=
                '<div class="bk-offers__card bk-offers__card--done">' +
                s2 +
                '<div class="bk-offers__text"><p class="bk-offers__title">' +
                f(t2.label("applied")) +
                "</p></div></div>";
            else if (t2.canClaim(r3)) {
              var c2 = n3.type === e;
              i2 +=
                '<div class="bk-offers__card">' +
                (c2 ? t2.thumb(n3.gift.image, n3.gift.title) : s2) +
                '<div class="bk-offers__text"><p class="bk-offers__title">' +
                (c2 ? "\u{1F381} " : "") +
                f(n3.cardTitle) +
                '</p><p class="bk-offers__sub">' +
                f(n3.cardText) +
                "</p>" +
                (c2
                  ? '<p class="bk-offers__product">' +
                    f(h(n3.gift.title)) +
                    ' <strong class="bk-offers__free">' +
                    f(t2.label("free")) +
                    "</strong></p>"
                  : "") +
                "</div>" +
                (c2 && !n3.gift.available
                  ? '<span class="bk-offers__soldout">' + f(t2.label("soldOut")) + "</span>"
                  : '<button type="button" class="bk-offers__btn" data-bk-' +
                    (c2 ? "claim" : "open") +
                    '="' +
                    f(n3.id) +
                    '">' +
                    f(n3.button) +
                    "</button>") +
                "</div>";
            } else
              t2.canSwap(r3) &&
                (i2 +=
                  '<div class="bk-offers__card bk-offers__card--swap">' +
                  (n3.type === e && n3.gift ? t2.thumb(n3.gift.image, n3.gift.title) : s2) +
                  '<div class="bk-offers__text"><p class="bk-offers__title">' +
                  f(n3.cardTitle) +
                  '</p><p class="bk-offers__sub">' +
                  f(t2.label("swapText") || "Replaces your current free gift") +
                  '</p></div><button type="button" class="bk-offers__btn" data-bk-swap="' +
                  f(n3.id) +
                  '">' +
                  f(n3.button) +
                  "</button></div>");
          }
        }),
          (i2 += '<p class="bk-offers__error" role="alert" hidden></p>');
        var r2 = document.createElement("div");
        (r2.className = "bk-offers__cards"), (r2.innerHTML = i2);
        var n2 = this.querySelector(".bk-offers__cards");
        n2 && n2.remove(), this.appendChild(r2);
      }
      productByVariant(e2, t2) {
        return (e2.m.products || []).filter(function (e3) {
          return e3.variantId === t2;
        })[0];
      }
      countText(e2, t2) {
        return this.label("pickerCount").replace("[count]", e2).replace("[max]", t2);
      }
      text(e2, i2) {
        return String(e2 || "")
          .replace("||amount||", i2.m.type === t ? i2.remaining : this.money(i2.remaining))
          .replace("||count||", i2.remaining)
          .replace("||label||", i2.m.label || "");
      }
      patchProgressBar() {
        var e2 = this,
          t2 = this.scope.querySelector("discount-progress-bar");
        if (t2) {
          var i2 = t2.querySelector(".wt-discount-bar__track");
          if (i2) {
            var r2 = this.state.milestones.map(function (t3) {
              return {
                done: t3.done,
                progress: t3.progress,
                label: t3.m.label,
                locked: e2.text(t3.m.message, t3),
                unlocked: t3.m.unlockedMessage || t3.m.label,
              };
            });
            if (r2.length) {
              var n2 = Array.prototype.slice.call(i2.querySelectorAll(".wt-discount-bar__milestone"));
              if (n2.length) {
                for (; n2.length < r2.length; ) {
                  var s2 = n2[n2.length - 1].cloneNode(!0);
                  i2.appendChild(s2), n2.push(s2);
                }
                var a2 = 100 / r2.length,
                  o2 = [],
                  c2 = -1;
                n2.forEach(function (e3, t3) {
                  if (t3 >= r2.length) e3.style.display = "none";
                  else {
                    o2.push(a2 * (t3 + 0.5)),
                      (e3.style.display = ""),
                      (e3.style.width = a2 + "%"),
                      e3.classList.toggle("wt-discount-bar__milestone--achieved", r2[t3].done);
                    var i3 = e3.querySelector(".wt-discount-bar__milestone__label");
                    i3 && r2[t3].label && (i3.textContent = r2[t3].label), r2[t3].done && (c2 = t3);
                  }
                });
                var l2,
                  d2 = r2.every(function (e3) {
                    return e3.done;
                  }),
                  u2 = i2.offsetWidth || 0,
                  h2 = u2 ? (26 / u2) * 100 : 6;
                (l2 = d2
                  ? 100
                  : c2 === -1
                    ? Math.max(0, o2[0] - h2) * r2[0].progress
                    : c2 < r2.length - 1
                      ? o2[c2] + Math.max(0, o2[c2 + 1] - h2 - o2[c2]) * r2[c2 + 1].progress
                      : o2[c2]),
                  t2.classList.add("bk-bar"),
                  i2.classList.toggle("wt-discount-bar__track--single", r2.length === 1),
                  i2.style.setProperty("--progress-percentage", l2.toFixed(2) + "%");
                var p3 = t2.querySelector(".wt-discount-bar__message");
                if (p3) {
                  var m2 = d2
                    ? [this.label("allUnlocked")]
                    : r2.map(function (e3) {
                        return e3.done ? e3.unlocked : e3.locked;
                      });
                  p3.classList.toggle("wt-discount-bar__message--success", d2),
                    (p3.innerHTML = m2
                      .filter(Boolean)
                      .map(function (e3) {
                        return "<p>" + f(e3) + "</p>";
                      })
                      .join(""));
                }
              }
            }
          }
        }
      }
      markGiftLines(e2, t2) {
        var i2 = this;
        this.state.giftLines.forEach(function (r2) {
          var n2 = i2.scope.querySelector("#CartDrawer-Item-" + r2.line);
          if (
            n2 &&
            (n2.classList.add("bk-gift-line"),
            e2 && t2 && t2.indexOf(r2.key) !== -1 && n2.classList.add(e2),
            r2.final_line_price === 0 && !n2.querySelector(".bk-gift-badge"))
          ) {
            var s2 = n2.querySelector(".wt-cart__item__name");
            if (s2) {
              var a2 = document.createElement("span");
              (a2.className = "bk-gift-badge"),
                (a2.textContent = i2.label("freeBadge")),
                s2.insertAdjacentElement("afterend", a2);
            }
          }
        });
        /* Brand Katha (23 Oct 2026): a product made free by Buy 2 Get 1 without the claim button
           gets the same FREE badge as the claimed gifts. */
        ((this.cart && this.cart.items) || []).forEach(function (r2) {
          if (r2.gift || r2.final_line_price !== 0 || !(r2.original_line_price > 0)) return;
          var n2 = i2.scope.querySelector("#CartDrawer-Item-" + r2.line);
          if (!n2) return;
          n2.classList.add("bk-gift-line", "bk-free-line");
          if (n2.querySelector(".bk-gift-badge")) return;
          var s2 = n2.querySelector(".wt-cart__item__name");
          if (s2) {
            var a2 = document.createElement("span");
            (a2.className = "bk-gift-badge"),
              (a2.textContent = i2.label("freeBadge")),
              s2.insertAdjacentElement("afterend", a2);
          }
        });
      }
      syncTabindex() {
        var e2 = this.closest("cart-drawer");
        if (e2) {
          var t2 = e2.hasAttribute("open") ? "0" : "-1";
          this.querySelectorAll("button").forEach(function (e3) {
            e3.setAttribute("tabindex", t2);
          });
        }
      }
      showError(e2) {
        var t2 =
          this.sheet && !this.sheet.hidden
            ? this.sheet.querySelector(".bk-offers__error")
            : this.querySelector(".bk-offers__error");
        t2 &&
          ((t2.textContent = (e2 && (e2.description || e2.message)) || this.label("error")),
          (t2.hidden = !1));
      }
      setBusy(e2, t2) {
        (o = e2),
          this.classList.toggle("bk-offers--busy", e2),
          this.sheet && this.sheet.classList.toggle("bk-offers--busy", e2),
          t2 && (this.loadingButton = t2),
          this.loadingButton && this.loadingButton.classList.toggle("bk-offers__btn--loading", e2);
      }
      onClick(e2) {
        var t2 = e2.target.closest("[data-bk-claim],[data-bk-open],[data-bk-change],[data-bk-swap]");
        if (t2 && !o) {
          if ((e2.preventDefault(), t2.hasAttribute("data-bk-swap"))) {
            var sw = this.milestone(t2.getAttribute("data-bk-swap"));
            return void (sw && this.swapTo(sw, t2));
          }
          var i2 = this.milestone(
            t2.getAttribute("data-bk-claim") ||
              t2.getAttribute("data-bk-open") ||
              t2.getAttribute("data-bk-change"),
          );
          i2 &&
            (t2.hasAttribute("data-bk-claim")
              ? this.addGifts([i2.m.gift.variantId], i2.m.id, t2)
              : t2.hasAttribute("data-bk-open")
                ? this.openPicker(i2)
                : this.changeGift(i2, t2));
        }
      }
      addGifts(e2, t2, r2) {
        var n2 = this;
        if (e2.length && !o) {
          var a2 = e2.map(function (e3) {
            var r3 = {};
            return (r3[i] = t2), { id: e3, quantity: 1, properties: r3 };
          });
          this.setBusy(!0, r2),
            m("cart/add.js", _({ items: a2 }))
              .then(function (e3) {
                (o = !1), window.sessionStorage.setItem(s, t2), g(e3);
              })
              .catch(function (e3) {
                n2.setBusy(!1), n2.showError(e3);
              });
        }
      }
      changeGift(e2, t2) {
        var i2 = this,
          n2 = {};
        e2.lines.forEach(function (e3) {
          n2[e3.key] = 0;
        }),
          this.setBusy(!0, t2),
          window.sessionStorage.setItem(r, e2.m.id),
          m("cart/update.js", _({ updates: n2 }))
            .then(function (e3) {
              (o = !1), g(e3);
            })
            .catch(function (e3) {
              window.sessionStorage.removeItem(r), i2.setBusy(!1), i2.showError(e3);
            });
      }
      buildPicker(e2) {
        var t2 = this,
          i2 = Math.max(0, e2.max - e2.claimed),
          r2 = this.pickable(e2)
            .map(function (e3) {
              return (
                '<li><label class="bk-offers__option">' +
                t2.thumb(e3.image, e3.title) +
                '<span class="bk-offers__option-text"><span class="bk-offers__option-title">' +
                f(u(e3.title)) +
                '</span><span class="bk-offers__option-price"><s>' +
                f(t2.money(e3.price)) +
                '</s> <strong class="bk-offers__free">' +
                f(t2.label("free")) +
                '</strong></span></span><input type="checkbox" class="bk-offers__check" value="' +
                f(e3.variantId) +
                '" aria-label="' +
                f(u(e3.title)) +
                '"></label></li>'
              );
            })
            .join(""),
          n2 = document.createElement("div");
        (n2.className = "bk-offers__sheet"),
          (n2.hidden = !0),
          n2.setAttribute("role", "dialog"),
          n2.setAttribute("aria-modal", "true"),
          n2.setAttribute("aria-label", e2.m.cardTitle || ""),
          (n2.innerHTML =
            '<div class="bk-offers__sheet-inner"><div class="bk-offers__sheet-head"><span class="bk-offers__icon" aria-hidden="true">\u{1F381}</span><div class="bk-offers__text"><p class="bk-offers__title">' +
            f(e2.m.cardTitle) +
            '</p><p class="bk-offers__sub">' +
            f(this.label("pickerSubtitle")) +
            '</p></div><button type="button" class="bk-offers__close" data-bk-close aria-label="Close">&times;</button></div><ul class="bk-offers__list">' +
            r2 +
            "</ul>" +
            (this.label("pickerNote")
              ? '<p class="bk-offers__note">' + f(this.label("pickerNote")) + "</p>"
              : "") +
            '<p class="bk-offers__error" role="alert" hidden></p><div class="bk-offers__sheet-foot"><span class="bk-offers__count" data-bk-count></span><button type="button" class="bk-offers__btn bk-offers__btn--wide" data-bk-add disabled>' +
            f(this.label("pickerAdd")) +
            "</button></div></div>");
        var s2 = function () {
            return Array.prototype.slice.call(n2.querySelectorAll(".bk-offers__check"));
          },
          a2 = function () {
            var i3 = s2().filter(function (e3) {
              return e3.checked;
            }).length;
            (n2.querySelector("[data-bk-count]").textContent = t2.countText(e2.claimed + i3, e2.max)),
              (n2.querySelector("[data-bk-add]").disabled = i3 === 0);
          };
        return (
          n2.addEventListener("change", function (e3) {
            e3.stopPropagation();
            var t3 = e3.target;
            if (t3.classList && t3.classList.contains("bk-offers__check")) {
              if (t3.checked) {
                var r3 = s2().filter(function (e4) {
                  return e4.checked;
                });
                r3.length > i2 &&
                  r3.forEach(function (e4) {
                    e4 !== t3 && r3.length > i2 && ((e4.checked = !1), r3.splice(r3.indexOf(e4), 1));
                  });
              }
              a2();
            }
          }),
          n2.addEventListener("click", function (i3) {
            if (i3.target === n2 || i3.target.closest("[data-bk-close]"))
              return i3.preventDefault(), void t2.closePicker();
            i3.target.closest("[data-bk-add]") &&
              !o &&
              (i3.preventDefault(),
              t2.addGifts(
                s2()
                  .filter(function (e3) {
                    return e3.checked;
                  })
                  .map(function (e3) {
                    return Number(e3.value);
                  }),
                e2.m.id,
                n2.querySelector("[data-bk-add]"),
              ));
          }),
          n2.addEventListener("keydown", function (e3) {
            e3.key === "Escape" && (e3.stopPropagation(), t2.closePicker());
          }),
          a2(),
          n2
        );
      }
      openPicker(e2) {
        var self = this;
        if (e2.m.allProducts && !this.pickable(e2).length) {
          if (this.loadingAll) return;
          this.loadingAll = !0;
          var btn = this.querySelector('[data-bk-open="' + e2.m.id + '"]');
          return (
            this.setBusy(!0, btn),
            void bkFetchAll()
              .then(function (list) {
                (e2.m.products = list),
                  (self.loadingAll = !1),
                  self.setBusy(!1),
                  self.sheet && (self.sheet.remove(), (self.sheet = null)),
                  self.openPickerNow(e2);
              })
              .catch(function (err) {
                (self.loadingAll = !1), self.setBusy(!1), self.showError(err);
              })
          );
        }
        this.openPickerNow(e2);
      }
      openPickerNow(e2) {
        this.sheet && this.sheetFor !== e2.m.id && (this.sheet.remove(), (this.sheet = null)),
          this.sheet ||
            ((this.sheet = this.buildPicker(e2)),
            (this.sheetFor = e2.m.id),
            document.body.appendChild(this.sheet)),
          (this.sheet.hidden = !1);
        var t2 = this.sheet.querySelector(".bk-offers__check");
        t2 && t2.focus({ preventScroll: !0 });
      }
      closePicker() {
        if (this.sheet) {
          this.sheet.hidden = !0;
          var e2 = this.querySelector("[data-bk-open]");
          e2 && e2.focus();
        }
      }
    }
    window.customElements.define("cart-offers", p2),
      document.addEventListener(
        "click",
        function (ev) {
          var b =
            ev.target && ev.target.closest && ev.target.closest("cart-remove-button, .js-counter-decrease");
          b && b.closest(".bk-gift-line:not(.bk-free-line)") && window.sessionStorage.setItem("bkOffersGiftRemoved", "1");
        },
        !0,
      ),
      (function () {
        var dr = document.getElementById("CartDrawer");
        if (!dr) return;
        var chk = function () {
          dr.querySelector(".wt-cart__drawer__body") &&
            !dr.querySelector("cart-offers") &&
            window.sessionStorage.removeItem("bkOffersGiftRemoved");
        };
        chk(),
          window.MutationObserver && new MutationObserver(chk).observe(dr, { childList: !0, subtree: !0 });
      })(),
      (function () {
        if (
          typeof window.publish == "function" &&
          !window.publish.bkPatched &&
          window.customElements.whenDefined
        ) {
          var e2 = window.publish,
            t2 = function (t3, i2) {
              var r2 =
                i2 &&
                i2.source === "product-form" &&
                i2.cartData &&
                i2.cartData.sections &&
                i2.cartData.sections["cart-drawer"];
              a = !!r2;
              try {
                return e2.apply(this, arguments);
              } finally {
                a = !1;
              }
            };
          (t2.bkPatched = !0), (window.publish = t2);
          try {
            publish = t2;
          } catch {}
          window.customElements.whenDefined("cart-drawer-items").then(function () {
            var e3 = window.customElements.get("cart-drawer-items").prototype,
              t3 = e3.onCartUpdate;
            typeof t3 != "function" ||
              e3.bkPatched ||
              ((e3.bkPatched = !0),
              (e3.onCartUpdate = function () {
                if (!a) return t3.apply(this, arguments);
              }));
          });
        }
      })(),
      ["cart-drawer-open", "cart-drawer-close"].forEach(function (e2) {
        document.addEventListener(e2, function () {
          document.querySelectorAll("cart-offers").forEach(function (e3) {
            e3.syncTabindex && e3.syncTabindex();
          });
        });
      }),
      document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", k) : k();
  }
  function bkMapProducts(ps) {
    return (ps || [])
      .map(function (pr) {
        var v2 = (pr.variants || []).filter(function (x) {
          return x.available;
        })[0];
        if (!v2) return null;
        var img = (pr.images && pr.images[0] && pr.images[0].src) || null;
        return {
          id: pr.id,
          title: pr.title,
          image: img ? img + (img.indexOf("?") > -1 ? "&" : "?") + "width=200" : null,
          variantId: v2.id,
          price: Math.round(100 * parseFloat(v2.price)),
          available: !0,
        };
      })
      .filter(Boolean);
  }
  function bkFetchAll() {
    return fetch(p() + "products.json?limit=250", { headers: { Accept: "application/json" } })
      .then(function (r2) {
        if (!r2.ok) throw new Error("products " + r2.status);
        return r2.json();
      })
      .then(function (data) {
        var list = bkMapProducts(data.products);
        try {
          window.sessionStorage.setItem("bkOffersAllProducts", JSON.stringify({ t: Date.now(), list }));
        } catch {}
        return list;
      });
  }
  function bkLoadAllCached(cfg) {
    var need = (cfg.milestones || []).filter(function (m2) {
      return m2.allProducts && !(m2.products || []).length;
    });
    if (need.length) {
      var cached = null;
      try {
        cached = JSON.parse(window.sessionStorage.getItem("bkOffersAllProducts") || "null");
      } catch {}
      cached && cached.list && Date.now() - cached.t < 18e5
        ? need.forEach(function (m2) {
            m2.products = cached.list;
          })
        : window.bkOffersAllLoading ||
          ((window.bkOffersAllLoading = !0),
          bkFetchAll()
            .catch(function () {})
            .then(function () {
              window.bkOffersAllLoading = !1;
            }));
    }
  }
  function d() {
    var e2 = document.getElementById("bk-cart-offers-config");
    if (!e2) return null;
    try {
      var t2 = JSON.parse(e2.textContent);
      return t2 && t2.enabled ? t2 : null;
    } catch (e3) {
      return console.error("cart-offers: invalid config", e3), null;
    }
  }
  function f(e2) {
    return String(e2 ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  function u(e2) {
    return String(e2 || "")
      .split("|")[0]
      .trim();
  }
  function h(e2) {
    var t2 = u(e2).split(/\s+/);
    return t2.length > 2 ? t2.slice(0, 2).join(" ") + "..." : t2.join(" ");
  }
  function p() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  }
  function m(e2, t2) {
    return fetch(p() + e2, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(t2),
    }).then(function (e3) {
      return e3.json().then(function (t3) {
        if (!e3.ok || (t3 && t3.status && t3.message)) throw t3;
        return t3;
      });
    });
  }
  function b() {
    return !!document.getElementById("main-cart-items");
  }
  function g(e2) {
    if (b()) window.location.reload();
    else {
      var t2 = document.querySelector("cart-drawer");
      t2 && typeof t2.renderContents == "function" && e2 && e2.sections && e2.sections["cart-drawer"]
        ? t2.renderContents(e2, !1)
        : document.dispatchEvent(new CustomEvent("cart-drawer:refresh"));
    }
  }
  function _(e2) {
    var t2 = { sections: l, sections_url: window.location.pathname };
    return (
      Object.keys(e2).forEach(function (i2) {
        t2[i2] = e2[i2];
      }),
      t2
    );
  }
  function v() {
    var e2 = document.getElementById("main-cart-items");
    e2 &&
      !e2.querySelector("cart-offers") &&
      d() &&
      fetch(p() + "cart.js", { headers: { Accept: "application/json" } })
        .then(function (e3) {
          return e3.json();
        })
        .then(function (t2) {
          if (t2.items && !t2.items.length) window.sessionStorage.removeItem("bkOffersGiftRemoved");
          if (t2.items && t2.items.length && !e2.querySelector("cart-offers")) {
            var r2 = document.createElement("cart-offers");
            (r2.className = "bk-offers bk-offers--page"),
              (r2.bkCart = {
                items: t2.items.map(function (e3, t3) {
                  return {
                    key: e3.key,
                    line: t3 + 1,
                    product_id: e3.product_id,
                    variant_id: e3.variant_id,
                    quantity: e3.quantity,
                    original_line_price: e3.original_line_price,
                    final_line_price: e3.final_line_price,
                    gift: (e3.properties && e3.properties[i]) || null,
                  };
                }),
              });
            var n2 = e2.querySelector(".wt-cart__header__progress") || e2.querySelector(".wt-cart__header");
            n2 && n2.appendChild(r2);
          }
        })
        .catch(function (e3) {
          console.error("cart-offers: could not load cart", e3);
        });
  }
  function k() {
    var e2 = document.getElementById("main-cart-items");
    e2 &&
      (v(),
      new MutationObserver(function () {
        e2.querySelector("cart-offers") || v();
      }).observe(e2, { childList: !0, subtree: !0 }));
  }
})();
//# sourceMappingURL=/cdn/shop/t/21/assets/cart-offers.js.map?v=18922354227089316341791807737